import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import Modal from "./modal";
import AppsLanding from "./components/AppsLanding";
import ContactSection from "./components/ContactSection";

const Top: React.FC = () => {
  const SERVICE_ID = "service_ow238xb";
  const TEMPLATE_ID = "template_f1649ml";
  const PUBLIC_KEY = "m5vh8N-Q_vGu6x2Fa";

  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  const params = {
    name,
    mail,
    phoneNumber,
    subject,
    message,
    allowContact: false,
  };

  const clear = () => {
    setName("");
    setMail("");
    setPhoneNumber("");
    setSubject("");
    setMessage("");
  };

  const handleSubmit = () => {
    emailjs.send(SERVICE_ID, TEMPLATE_ID, params, PUBLIC_KEY).then(
      () => {
        clear();
        setShowModal(true);
      },
      (err) => {
        console.log("ERR", err);
      }
    );
  };

  return (
    <>
      {showModal && <Modal setShowModal={setShowModal} />}
      <div className="bg-white">
        <AppsLanding contactHref="#contact">
          <ContactSection
            mail={mail}
            message={message}
            name={name}
            phoneNumber={phoneNumber}
            subject={subject}
            onMailChange={setMail}
            onMessageChange={setMessage}
            onNameChange={setName}
            onPhoneNumberChange={setPhoneNumber}
            onSubjectChange={setSubject}
            onSubmit={handleSubmit}
          />
        </AppsLanding>
      </div>
    </>
  );
};

export default Top;
